import React from "react";
import { View, Text, Image } from "react-native";
import logoApp from "../../../../img/logo_app.png";
import { corTextoSobre, gradienteHero } from "../../../../theme/cores";

interface HeaderProps {
  dados_empresa: any;
  primaryColor: string;
  colorMode: any;
}

const DOURADO = "#E3BF7A";

const Header: React.FC<HeaderProps> = ({
  dados_empresa,
  primaryColor,
  colorMode,
}) => {
  const corTexto = corTextoSobre(primaryColor);

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: primaryColor,
        backgroundImage: gradienteHero(primaryColor),
        paddingTop: 36,
        paddingBottom: 80,
        paddingLeft: 20,
        paddingRight: 20,
        boxSizing: "border-box",
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        filter: colorMode == "dark" ? "brightness(0.75)" : undefined,
      }}
    >
      <View
        style={{
          width: 112,
          height: 112,
          borderRadius: 56,
          padding: 6,
          backgroundColor: "rgba(255,255,255,0.12)",
          marginBottom: 16,
        }}
      >
        <View
          style={{
            flex: 1,
            borderRadius: 50,
            backgroundColor: "#fff",
            overflow: "hidden",
            alignItems: "center",
            justifyContent: "center",
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 6 },
            shadowOpacity: 0.25,
            shadowRadius: 14,
          }}
        >
          <Image
            source={dados_empresa.logo || logoApp}
            style={{ width: "86%", height: "86%" }}
            resizeMode="contain"
          />
        </View>
      </View>

      <Text
        style={{
          color: DOURADO,
          fontSize: 12,
          fontWeight: "700",
          letterSpacing: 3,
          textAlign: "center",
          marginBottom: 6,
        }}
      >
        TRADIÇÃO · ESTILO · PRECISÃO
      </Text>

      <Text
        style={{
          color: corTexto,
          fontSize: 26,
          fontWeight: "800",
          textAlign: "center",
        }}
        numberOfLines={2}
      >
        {dados_empresa.nomeFantasia}
      </Text>
    </div>
  );
};

export default Header;
